import { styled } from "styled-components";

export const Alert = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  background: transparent;
  color: ${({ theme }) => theme.colors.primary.default};
`;

export const Success = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  background: transparent;
  color: ${({ theme }) => theme.colors.success.default};
`;
